import React from 'react';
import './BackdropOverlay.css'
import { Box } from "@mui/material";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const BackdropModal = (props) => {
    return (<Box className='backdrop'>
      <IconButton className='close' onClick={props.onClose} sx={{ color: "#9C7945"}}>
          <CloseIcon sx={{fontSize:'3rem'}}/>
        </IconButton>
    </Box>);
  };

export default BackdropModal;